var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-modal',_vm._b({on:{"modal:toggle":_vm.onModalToggle}},'base-modal',{
    opened: _vm.opened,
    showClose: _vm.showClose,
    type: _vm.type,
    showCancel: _vm.showCancel,
    cancelLabel: _vm.cancelLabel,
    modalClasses: _vm.modalClasses,
    noCloseOnBackdrop: _vm.noCloseOnBackdrop,
  },false),[_c('template',{slot:"header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"modal-title-notification"}},[_vm._v(_vm._s(_vm.title))])]),_vm._t("default"),_c('template',{slot:"footer"},[(_vm.buttons)?_vm._l((_vm.buttons),function(button){return _c('button-component',_vm._b({key:button.id,class:{ disabled: _vm.buttonsDisable },on:{"button:click":function($event){return _vm.eventHandler(button.event)}}},'button-component',button,false))}):_vm._e()],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }